export default {
  title: "Bedrijven overzicht",
  noRecords: "Geen bedrijven gevonden",
}
